import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit_hover",
  "use": "edit_hover-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"edit_hover\"><g fill-rule=\"evenodd\"><path d=\"M0 15.97h16v-1H0zM8.977 2.185l3.9 3.899-8.027 7.885H1v-3.928l7.977-7.856zm1.908-1.88a1.07 1.07 0 011.503.006l2.393 2.392c.202.202.313.472.312.76a1.06 1.06 0 01-.319.756L13.59 5.383l-3.9-3.9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id